export default __webpack_public_path__ + "static/media/example.13f3329c.mp3";